import { useEffect, useRef } from 'react'

interface SelfVideoProps {
  streamRef: React.MutableRefObject<MediaStream | null>
  isRecording: boolean
}

export function SelfVideo({ streamRef, isRecording }: SelfVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const el = videoRef.current
    if (!el) return
    if (isRecording && streamRef.current) {
      el.srcObject = streamRef.current
      el.style.display = 'block'
      el.play().catch(() => {})
    } else {
      el.srcObject = null
      el.style.display = 'none'
    }
  }, [isRecording, streamRef])

  return (
    <video
      ref={videoRef}
      id="candidate-video-preview"
      autoPlay
      muted
      playsInline
      style={{ display: 'none', width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10, position: 'relative', zIndex: 1, pointerEvents: 'none' }}
    />
  )
}
